// Page data is kept only for the current browser session. This lets portal
// pages prefetch each other without persisting customer data on the device.
const shipmentListCache = new Map<string, unknown>();
const shipmentDetailsCache = new Map<string, unknown>();
const analyticsOverviewCache = new Map<string, unknown>();
const analyticsFilterOptionsCache = new Map<string, unknown>();
const portalMembersCache = new Map<string, unknown>();
const MAX_CACHE_ENTRIES = 100;

function setBounded(cache: Map<string, unknown>, key: string, value: unknown) {
  cache.delete(key);
  cache.set(key, value);
  while (cache.size > MAX_CACHE_ENTRIES) cache.delete(cache.keys().next().value);
}

export function getCachedShipmentList<T>(key: string): T | null {
  return (shipmentListCache.get(key) as T | undefined) || null;
}

export function setCachedShipmentList<T>(key: string, value: T) {
  setBounded(shipmentListCache, key, value);
}

export function getCachedShipmentDetails<T>(key: string): T | null {
  return (shipmentDetailsCache.get(key) as T | undefined) || null;
}

export function setCachedShipmentDetails<T>(key: string, value: T) {
  setBounded(shipmentDetailsCache, key, value);
}

export function getCachedAnalyticsOverview<T>(key: string): T | null {
  return (analyticsOverviewCache.get(key) as T | undefined) || null;
}

export function setCachedAnalyticsOverview<T>(key: string, value: T) {
  setBounded(analyticsOverviewCache, key, value);
}

export function getCachedAnalyticsFilterOptions<T>(key: string): T | null {
  return (analyticsFilterOptionsCache.get(key) as T | undefined) || null;
}

export function setCachedAnalyticsFilterOptions<T>(key: string, value: T) {
  setBounded(analyticsFilterOptionsCache, key, value);
}

export function getCachedPortalMembers<T>(key: string): T | null {
  return (portalMembersCache.get(key) as T | undefined) || null;
}

export function setCachedPortalMembers<T>(key: string, value: T) {
  setBounded(portalMembersCache, key, value);
}
